import * as React from 'react'

function ImagesPhotoEdit(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 18H7a2 2 0 01-2-2V5a2 2 0 012-2h13a2 2 0 012 2v11a2 2 0 01-2 2z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.996 21H4a2 2 0 01-2-2V8.399M11.346 6.821A1.667 1.667 0 118.99 9.177a1.667 1.667 0 012.356-2.355"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 13.833l-3.386-2.709a1 1 0 00-1.406.156l-2.572 3.215a1 1 0 01-1.406.156l-1.299-1.039a1 1 0 00-1.393.141L7 18"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { ImagesPhotoEdit }
